(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .factory('LicenceService', LicenceServiceFn);

    /* main settings service for licences  */
    LicenceServiceFn.$inject = ['$http'];

    function LicenceServiceFn($http) {

        var baseUrl = '/api/licences/';
        var service = {
            queryLicence: queryLicence,
            getLicence: getLicence,
            saveLicence: saveLicence,
            updateLicence: updateLicence
        };

        return service;

        /* get all items */
        function queryLicence() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        }

        /* get one item */
        function getLicence(licenceId, loadImage) {
            return $http.get(baseUrl + licenceId + '/' + (loadImage ? loadImage : false));
        }

        /* save item */
        function saveLicence(item) {
            return $http.post(baseUrl, item);
        }

        /* update item */
        function updateLicence(licenceId, item) {
            return $http.put(baseUrl + licenceId, item);
        }
    }
})();